import React from 'react';

/**
 * Consistent loading spinner component for the Honey app
 * 
 * Usage:
 *   <LoadingSpinner />                    // Default: "Loading..."
 *   <LoadingSpinner message="Loading recipes..." />
 *   <LoadingSpinner fullScreen />         // Centered on full viewport
 *   <LoadingSpinner size="sm" />          // Smaller bee
 */

// Activity indicator style spinner - rays in a circle that appear to rotate
const RaySpinner = () => (
  <div className="relative w-5 h-5 animate-spin">
    {[...Array(8)].map((_, i) => (
      <div
        key={i}
        className="absolute w-0.5 h-1.5 bg-amber-600 rounded-full left-1/2 top-0"
        style={{
          transform: `translateX(-50%) rotate(${i * 45}deg)`,
          transformOrigin: '50% 10px',
          opacity: 0.25 + (i * 0.1),
        }}
      />
    ))}
  </div>
);

const LoadingSpinner = ({ 
  message = 'Loading...', 
  fullScreen = false,
  size = 'md',  // 'sm', 'md', 'lg'
  className = ''
}) => {
  const beeSize = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24'
  }[size] || 'w-16 h-16';

  const containerClass = fullScreen 
    ? 'min-h-screen flex flex-col items-center justify-center bg-amber-50'
    : 'flex flex-col items-center justify-center py-12';

  return (
    <div className={`${containerClass} ${className}`}>
      <img 
        src="/HoneyCookingCompanion_bee.svg" 
        alt="Loading" 
        className={`${beeSize} mb-4 animate-bounce`}
      />
      <div className="flex items-center gap-2">
        <RaySpinner />
        <p className="text-gray-500">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
